import { GridColDef } from '@mui/x-data-grid-premium'
import { SensorBatteryStats } from 'src/api'

export namespace SensorBatteryStatsColumns {
  export const BatteryStartValue: GridColDef<SensorBatteryStats> = {
    field: 'batteryStartValue',
    headerName: 'Battery Start Value',
    type: 'number',
    minWidth: 160,
    editable: false
  }

  export const DaysSinceLastCharge: GridColDef<SensorBatteryStats> = {
    field: 'daysSinceLastCharge',
    headerName: 'Days Since Last Charge',
    type: 'number',
    minWidth: 180,
    editable: false
  }

  export const CurrentBattery: GridColDef<SensorBatteryStats> = {
    field: 'currentBattery',
    headerName: 'Current Battery Value',
    type: 'number',
    minWidth: 170,
    editable: false
  }

  export const DailyDischargeRate: GridColDef<SensorBatteryStats> = {
    field: 'dailyDischargeRate',
    headerName: 'Discharge Rate',
    type: 'number',
    minWidth: 200,
    editable: false
  }

  export const EstimatedDaysRemaining: GridColDef<SensorBatteryStats> = {
    field: 'estimatedDaysRemaining',
    headerName: 'Forecast',
    type: 'string',
    minWidth: 150,
    editable: false,
    valueGetter: ({ row }) => row.estimatedDaysRemaining || 'n/a'
  }
}
